import { Component, OnInit } from '@angular/core';
import { WebApiObservableService } from 'app/web-api-observable/web-api-observable.service';

@Component({
  selector: 'app-order-placed',
  templateUrl: './order-placed.component.html',
  styleUrls: ['./order-placed.component.css']
})
export class OrderPlacedComponent implements OnInit {
	order_data:any=[];
	order_details:any=[];
  search_array={};
  errorMessage={};
  order=[];
  payment:any=[];
  customer:any=[];
  foodsordered:any=[];
  address:any=[];
  constructor(private orderplaced: WebApiObservableService ) { }

  ngOnInit() {
     $('.spin').addClass('loading');
   this.order_data=JSON.parse(localStorage.getItem('ORDER-PLACED'));
  
   this.order_details=this.order_data[0];
    this.search_array={      
      customer_id: this.order_details.customer_id,
      order_id: this.order_details.id
    };
     this.orderplaced
            .getServiceWithOrderDetail('/customerorders',this.search_array)
            .subscribe(
                result => {                 
                  this.order=result.order_dtl;
                  this.payment= result.payment_type;
                  this.customer= result.customer;
                  this.foodsordered=result.ordered_food;
                  this.address=result.customer_address;
                  localStorage.removeItem('ORDER-PLACED');
                   $('.spin').removeClass('loading');
                },
                error => { $('.spin').removeClass('loading');   this.errorMessage = <any>error}
            );
    }

  }





// WEBPACK FOOTER //
// D:/deliverproject/eatasiafood/src/app/order-placed/order-placed.component.ts